import { render, staticRenderFns } from "./SearchICard.vue?vue&type=template&id=544c1e41&"
import script from "./SearchICard.vue?vue&type=script&lang=js&"
export * from "./SearchICard.vue?vue&type=script&lang=js&"
import style0 from "./SearchICard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports